import { defineComponent as w, useCssVars as B, unref as g, ref as L, watch as v, computed as $, openBlock as u, createBlock as f, normalizeClass as d, withCtx as i, createSlots as b, renderSlot as r, createCommentVNode as h, createVNode as p } from "vue";
import { _ as S, a as H } from "./FooterBase.vue_vue_type_script_setup_true_lang-138e024e.mjs";
import { C as c } from "./NavigationDrawer-b0e76b56.mjs";
import { S as N, _ as P } from "./NavigationDrawer.vue_vue_type_style_index_1_scoped_fd5bf7fb_lang-a9e75722.mjs";
import { bP as V, c5 as W, bW as M } from "./VTextarea-a9029832.mjs";
import "./VFooter-c3bcfdb6.mjs";
const R = /* @__PURE__ */ w({
  props: {
    headerColor: {
      type: String,
      default: "highlight-side-panel"
    },
    mainColor: {
      type: String,
      default: "dark-bg"
    },
    navigationColor: {
      type: String,
      default: "side-panel-bg"
    },
    rightPanelColor: {
      type: String,
      default: "player-bg"
    },
    footerColor: {
      type: String,
      default: "dark-bg"
    },
    appBarExtensionHeight: {
      type: Number || String,
      default: 0
    },
    mobile: {
      type: Boolean,
      default: !1
    },
    footerExtended: {
      type: Boolean,
      default: !1
    },
    hideFooterLogo: {
      type: Boolean,
      default: !1
    },
    header: {
      type: Boolean,
      default: !1
    },
    navigation: {
      type: Boolean,
      default: !1
    },
    headerUnderneath: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    },
    navigationWidth: {
      type: String,
      default: "300"
    },
    navigationRail: {
      type: Boolean,
      default: !1
    },
    expandOnHover: {
      type: Boolean,
      default: !1
    },
    rightNavigationWidth: {
      type: String,
      default: "300"
    },
    rightNavigation: {
      type: Boolean,
      default: !1
    },
    mobileMenuButtons: {
      type: Boolean,
      default: !0
    },
    mobileLeftHamburger: {
      type: Boolean,
      default: !1
    },
    mobileCenterHeaderLogo: {
      type: Boolean,
      default: !1
    },
    rightNavigationOrder: {
      type: Number,
      default: 1
    },
    headerHeight: {
      type: Number,
      default: 60
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    center: {
      type: Boolean,
      default: !1
    },
    disableResizeWatcher: {
      type: Boolean,
      default: !1
    },
    disableRouteWatcher: {
      type: Boolean,
      default: !1
    },
    permanentNavigation: {
      type: Boolean,
      default: !1
    },
    logoHref: {
      type: String,
      default: "/"
    },
    footer: {
      type: Boolean,
      default: !1
    },
    showCharactrInfo: {
      type: Boolean,
      default: !1
    },
    showSocialMedia: {
      type: Boolean,
      default: !0
    },
    showLinks: {
      type: Boolean,
      default: !0
    },
    footerHeight: {
      type: Number,
      default: 60
    },
    footerLinks: {
      type: Array,
      default: () => []
    },
    headerLinks: {
      type: Array,
      default: () => []
    },
    mainPaddingClass: {
      type: String,
      default: "pa-2"
    },
    activeLink: {
      type: String,
      default: ""
    },
    underlineEffect: {
      type: Boolean,
      default: !1
    },
    termsLink: {
      type: String,
      default: ""
    },
    privacyLink: {
      type: String,
      default: ""
    },
    socialMediaLinks: {
      type: Array,
      default: N
    },
    rightPanelFab: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["logIn", "signUp", "logOut", "logoClicked", "updateRailValue", "rightPanelOpened"],
  setup(a, { expose: y, emit: s }) {
    const e = a;
    B((t) => ({
      ccdbbbf2: g(C)
    }));
    const l = L(e.navigation);
    e.mobile && (l.value = !1), v(
      () => e.navigation,
      (t) => {
        !e.mobile && t && !l.value && (l.value = !0);
      }
    ), v(
      () => e.mobile,
      (t) => {
        e.navigation && (l.value = !t);
      }
    );
    const m = () => {
      l.value = !l.value;
    }, k = () => {
      e.mobile && l.value && m();
    }, C = $(() => e.mobile ? `${e.headerHeight}px` : 0);
    return y({
      toggleLeftPanel: m
    }), (t, o) => (u(), f(g(V), {
      class: d([`app-${a.mainColor}`])
    }, {
      default: i(() => [
        e.header ? (u(), f(S, {
          key: 0,
          class: d([`header-${a.headerColor}`]),
          outline: e.outline,
          "header-underneath": e.navigation ? e.headerUnderneath : !1,
          "header-height": a.headerHeight,
          "show-menu": e.navigation,
          "show-close": l.value,
          mobile: e.mobile,
          "extension-height": e.appBarExtensionHeight,
          "show-mobile-menu-buttons": e.mobileMenuButtons,
          "mobile-center-header-logo": e.mobileCenterHeaderLogo,
          "mobile-left-hamburger": e.mobileLeftHamburger,
          "logo-href": e.logoHref,
          "active-link": a.activeLink,
          onMenuClicked: o[0] || (o[0] = (n) => l.value = !l.value),
          onCloseClicked: o[1] || (o[1] = (n) => l.value = !1),
          links: e.headerLinks,
          navigation: e.navigation || e.rightNavigation,
          onSignUp: o[2] || (o[2] = (n) => s("signUp")),
          onLogIn: o[3] || (o[3] = (n) => s("logIn")),
          onLogOut: o[4] || (o[4] = (n) => s("logOut")),
          onLogoClicked: o[5] || (o[5] = (n) => s("logoClicked"))
        }, b({
          "header-links": i(() => [
            r(t.$slots, "header-links", {}, void 0, !0)
          ]),
          "mobile-link": i(() => [
            r(t.$slots, "mobile-link", {}, void 0, !0)
          ]),
          "header-extension": i(() => [
            r(t.$slots, "header-extension", {}, void 0, !0)
          ]),
          _: 2
        }, [
          t.$slots["custom-logo"] ? {
            name: "custom-logo",
            fn: i(() => [
              r(t.$slots, "custom-logo", {}, void 0, !0)
            ])
          } : void 0
        ]), 1032, ["class", "outline", "header-underneath", "header-height", "show-menu", "show-close", "mobile", "extension-height", "show-mobile-menu-buttons", "mobile-center-header-logo", "mobile-left-hamburger", "logo-href", "active-link", "links", "navigation"])) : h("", !0),
        e.navigation ? (u(), f(c, {
          key: 1,
          modelValue: l.value,
          "onUpdate:modelValue": o[6] || (o[6] = (n) => l.value = n),
          mobile: e.mobile,
          order: e.mobile ? 0 : e.headerUnderneath ? -1 : 0,
          location: e.mobile ? "bottom" : "left",
          class: d([{ fullscreen: e.mobile }]),
          outline: e.outline,
          logo: e.headerUnderneath,
          "navigation-width": e.mobile ? "100%" : e.navigationWidth,
          "navigation-rail": a.navigationRail,
          "expand-on-hover": a.expandOnHover,
          "logo-height": e.headerHeight,
          "toolbar-height": e.headerHeight,
          "disable-resize-watcher": e.disableResizeWatcher,
          "disable-route-watcher": e.disableRouteWatcher,
          permanent: e.permanentNavigation,
          touchless: "",
          "logo-href": e.logoHref,
          onCloseClicked: o[7] || (o[7] = (n) => l.value = !l.value),
          onLogoClicked: o[8] || (o[8] = (n) => s("logoClicked")),
          "onUpdate:rail": o[9] || (o[9] = (n) => s("updateRailValue", n)),
          "show-footer": e.footer,
          terms: a.termsLink,
          privacy: a.privacyLink,
          "social-media-links": a.socialMediaLinks,
          color: a.navigationColor
        }, {
          default: i(() => [
            r(t.$slots, "navigation", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["modelValue", "mobile", "order", "location", "class", "outline", "logo", "navigation-width", "navigation-rail", "expand-on-hover", "logo-height", "toolbar-height", "disable-resize-watcher", "disable-route-watcher", "permanent", "logo-href", "show-footer", "terms", "privacy", "social-media-links", "color"])) : h("", !0),
        e.rightNavigation ? (u(), f(c, {
          key: 2,
          "right-panel": !0,
          onRightPanelOpened: o[10] || (o[10] = (n) => s("rightPanelOpened", n)),
          "right-panel-fab": a.rightPanelFab,
          mobile: e.mobile,
          order: "2",
          location: e.mobile ? "bottom" : "right",
          outline: e.outline,
          "navigation-width": e.mobile ? "100%" : e.rightNavigationWidth,
          "disable-route-watcher": e.disableRouteWatcher,
          permanent: e.permanentNavigation,
          touchless: "",
          color: a.rightPanelColor
        }, {
          default: i(() => [
            r(t.$slots, "rightNavigation", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["right-panel-fab", "mobile", "location", "outline", "navigation-width", "disable-route-watcher", "permanent", "color"])) : h("", !0),
        e.footerExtended ? (u(), f(H, {
          key: 3,
          order: "2",
          class: d([`footer-${a.footerColor}`]),
          extended: e.footerExtended,
          outline: e.outline,
          links: e.footerLinks,
          "hide-logo": e.hideFooterLogo,
          "footer-height": e.footerHeight,
          "show-charactr-info": e.showCharactrInfo,
          "show-social-media": e.showSocialMedia,
          "show-links": e.showLinks,
          "social-media-links": a.socialMediaLinks
        }, b({
          "footer-left-links": i(() => [
            r(t.$slots, "footer-left-links", {}, void 0, !0)
          ]),
          "footer-right-links": i(() => [
            r(t.$slots, "footer-right-links", {}, void 0, !0)
          ]),
          _: 2
        }, [
          t.$slots["custom-logo"] ? {
            name: "custom-logo",
            fn: i(() => [
              r(t.$slots, "custom-logo", {}, void 0, !0)
            ])
          } : void 0,
          t.$slots["custom-logo-footer"] ? {
            name: "custom-logo-footer",
            fn: i(() => [
              r(t.$slots, "custom-logo-footer", {}, void 0, !0)
            ])
          } : void 0,
          t.$slots["custom-top-footer"] ? {
            name: "custom-top-footer",
            fn: i(() => [
              r(t.$slots, "custom-top-footer", {}, void 0, !0)
            ])
          } : void 0
        ]), 1032, ["class", "extended", "outline", "links", "hide-logo", "footer-height", "show-charactr-info", "show-social-media", "show-links", "social-media-links"])) : h("", !0),
        p(g(W), {
          class: d([
            { "centered-content": e.center, "blur-bg": l.value && a.mobile, "pr-0": a.rightPanelFab && a.rightNavigation }
          ]),
          onClick: k,
          scrollable: e.scrollable
        }, {
          default: i(() => [
            p(g(M), {
              class: d(e.mainPaddingClass),
              style: { maxWidth: "100%" }
            }, {
              default: i(() => [
                r(t.$slots, "default", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["class", "scrollable"])
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
const F = /* @__PURE__ */ P(R, [["__scopeId", "data-v-0d4f2024"]]);
export {
  F as CLayout
};
